module.exports = __webpack_public_path__ + "img/id.a838dce1.png";